import React from 'react';

import { BaseMotionTokenTable, type MotionTokenTableValue } from '../base-table';

const values: MotionTokenTableValue[] = [
	{
		tokenName: 'motion.duration.instant',
		useFor: 'Instant feedback (e.g. focus state)',
		value: '0ms',
	},
	{
		tokenName: 'motion.duration.xxshort',
		useFor: 'High-frequency interactions (e.g. list item hover)',
		value: '50ms',
	},
	{
		tokenName: 'motion.duration.xshort',
		useFor: 'Subtle pressed states, quick exits',
		value: '100ms',
	},
	{
		tokenName: 'motion.duration.short',
		useFor: 'Interactive highlight (e.g. emphasised hover and pressed states)',
		value: '150ms',
	},
];

/**
 * __Duration interaction table__
 */
export const MotionDurationInteractionTable = (): React.JSX.Element => {
	return <BaseMotionTokenTable values={values} testId="motion-duration-interaction-table" />;
};
